import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, MapPinned } from "lucide-react";
import { api } from "@/lib/api";
import { EmptyState, PageHeader } from "@/components/common";

export const ResortLinks = ({ resorts, testId = "resort-links" }) => (
  <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid={testId}>
    {resorts.map((r) => (
      <Link key={r.id} to={`/resort/${r.id}`} className="panel !p-5 flex items-center gap-3 hover:border-primary transition-colors" data-testid={`resort-link-${r.id}`}>
        <span className="h-11 w-11 rounded-xl bg-primary/12 text-primary grid place-items-center shrink-0"><MapPinned className="h-5 w-5" /></span>
        <div className="min-w-0 flex-1"><p className="font-heading font-semibold truncate">{r.name}</p>{r.petugas && <p className="text-xs text-muted-foreground truncate">{r.petugas.name}</p>}</div>
        <ChevronRight className="h-5 w-5 text-muted-foreground" />
      </Link>
    ))}
  </div>
);

export default function LaporanResortPage() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/resorts").then((r) => setItems(r.data.resorts)).catch(() => setItems([])); }, []);
  return (
    <div>
      <PageHeader title="Laporan Resort" />
      {items === null ? <p className="text-muted-foreground">Memuat...</p> : items.length === 0 ? <EmptyState icon={MapPinned} title="Belum ada resort" testId="laporan-resort-empty" /> : <ResortLinks resorts={items} />}
    </div>
  );
}
